<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <template>
            <div
              id="idTable"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
              >
                <thead>
                  <tr>
                    <th
                      id="dadoMovimentacaoHeader"
                      style="text-align: center;"
                    >
                      Produtos
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-for="item in dadosProdutos"
                  :key="item.id"
                >
                  <tr>
                    <td
                      id="dadoMovimentacao"
                      style="text-align: left;"
                    >
                      {{ item.produto }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <router-link
              to="/analise-produto5/produtos-nao-comercializados"
              :style="styleObject"
              class="text-center"
            >
              <div
                id="linkDetalhePrincipaisClientes"
                class="text-center"
              >
                <v-icon
                  id="iconLinkPrincipaisClientes"
                  class="text-center"
                >
                  mdi-chevron-double-down
                </v-icon><br>
              </div>
            </router-link>
          </template>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Produto from '../../../../../services/analiseproduto5'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowMixComercilizados',
    emits: [],
    components: {},
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      exibirMix: false,
      mixVendido: 0,
      produtosAtivos: 0,
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      produtos: [],
      cidades: [],
      linhasProducao: [],
      dadosProdutos: [],
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, empresa, vendedor, area, redes, supervisor, receita, segmento, categoria, promotor, classificacao, linhasProducao, produtos, cidades) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = empresa
        this.vendedor = vendedor
        this.area = area
        this.rede = redes
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.produtos = produtos
        this.cidades = cidades
        this.linhasProducao = linhasProducao

        this.showUpdateDadosMixComercializado()
      },

      async showUpdateDadosMixComercializado () {
        this.loading = true
        this.exibirMix = false

        this.mixVendido = 0
        this.produtosAtivos = 0

        this.dadosProdutos = []

        await Produto.showDadosNaoComercializado(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.produtos, this.cidades, this.linhasProducao).then(resposta => {
          if (resposta.data.status) {
            this.dadosProdutos = resposta.data.dadosProdutos.map((item) => {
              var listaFaturamento = ({
                produto: item.nome,
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há dados semestral para a exibição') {
            this.mixVendido = 0

            this.produtosAtivos = 0

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirMix = true
        })
      },
    },
  }
</script>

<style scoped>
 @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 360px;
      margin: 0 0 0 -1rem;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
